import type { TAnalyticsData, TSessionAnalytics } from "@/types/TAnalytics";

export async function getAnalytics(days: number = 30): Promise<TAnalyticsData> {
  const response = await fetch(`/api/analytics?days=${days}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch analytics: ${response.status}`);
  }
  
  return response.json();
}

export async function getSessionAnalytics(days: number = 30): Promise<TSessionAnalytics> {
  const response = await fetch(`/api/heygen/session-analytics?days=${days}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch session analytics: ${response.status}`);
  }

  return response.json();
}
